import React from "react";
import { styles } from "./Styles";
import { Box, IconButton, Typography } from "@mui/material";
import { EditIcon } from "../../utils/constants/Icons.constants";

const ViewEditHeader = ({
  edit,
  title,
  handleEdit,
  ReportDate,
  ReportEmail,
}) => {
  const classes = styles;
  return (
    <div style={styles.header}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
      >
        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          <Typography color="primary" style={classes.title}>
            {title}
          </Typography>
          <Typography style={classes.email}>{ReportEmail}</Typography>
        </div>
        <Box display={"flex"} alignItems={"center"}>
          <Typography
            sx={{
              p: 2,
            }}
          >
            {ReportDate}
          </Typography>

          {edit && (
            <>
              <IconButton sx={classes.edit} onClick={handleEdit}>
                <EditIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default ViewEditHeader;
